import React from 'react'
import PropTypes from 'prop-types'

import ios from '../../components/developerApi/developerSdk/WorkoutPreset/IOS/WorkoutPresetComponent'
import android from '../../components/developerApi/developerSdk/WorkoutPreset/Android/WorkoutPresetComponent'

import './workoutPresetLayout.scss'

const WORKOUT_PRESET = {
    ios,
    android,
    web: () => <h1>Not Implemented Yet</h1>,
}

class WorkoutPresetLayout extends React.Component {
    render() {
        const WorkoutPresetComponent = WORKOUT_PRESET[this.props.api]

        return <div className="workout-preset-layout">
            <h2>Workout Preset</h2>
            <WorkoutPresetComponent />
        </div>
    }
}

WorkoutPresetLayout.propTypes = {
    api: PropTypes.string.isRequired,
}

export default WorkoutPresetLayout



// WEBPACK FOOTER //
// ./src/layouts/WorkoutPreset/WorkoutPresetLayout.js